export default class SolidarityRoutingService {
  constructor($transitions) {
    'ngInject';
    this.transitions = $transitions;
    this.start();
  }

  start() {
    this.visited = {};
    this.registerOnBeforeTo('my-solidarity');
  }

  registerOnBeforeTo(stateName) {
    const criteria = { to: stateName };
    this.transitions.onBefore(criteria, () => this.setVisited(stateName));
  }

  setVisited(stateName) {
    this.visited[stateName] = true;
  }

  stateVisited(stateName) {
    return this.visited[stateName] === true;
  }
}



// WEBPACK FOOTER //
// ./client/app/solidarity.module/features/solidarityRouting/solidarityRouting.service.js